import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { appEvents } from 'modules';



export interface IProps {
  title?: string;
  body?: string;

  onConfirm?: () => void;
}

export const FC: React.FC<IProps> = props => {



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  return (
    <Dialog
      open
      onClose={handleClose}>
      <DialogTitle>
        {props.title || 'Confirm'}
      </DialogTitle>

      <DialogContent>
        {props.body || 'Are you sure you want to do this?'}
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          onClick={handleClose}>
          Cancel
        </Button>

        <Button onClick={() => {
          if (props.onConfirm) {
            props.onConfirm();
          }
          handleClose();
        }}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
